function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { ApplicationCRMMetadataSchema, ApplicationSettingsSchema } from "@superwall-me/schema";
import db, { ApplicationPlatform } from "./db";
export const getSettings = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*(applicationId) {
        const application = (yield db.applicationSettings.findUnique({
            where: {
                applicationId
            },
            select: {
                settings: true
            }
        })) || {
            settings: {}
        };
        return parseApplicationSettings(application).settings;
    });
    return function getSettings(applicationId) {
        return _ref.apply(this, arguments);
    };
}();
export const ApplicationPlatformStringMap = {
    [ApplicationPlatform.STRIPE]: "Web 2 App",
    [ApplicationPlatform.ANDROID]: "Android",
    [ApplicationPlatform.IOS]: "iOS",
    [ApplicationPlatform.WEB]: "Stripe"
};
export const setSettings = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*(applicationId, settings) {
        const applicationSettings = yield db.applicationSettings.findUnique({
            where: {
                applicationId
            }
        });
        let existingSettings = (applicationSettings || {
            settings: {}
        }).settings;
        Object.entries(settings).forEach(([key, value])=>{
            if (value === null) {
                delete existingSettings[key];
            } else {
                existingSettings[key] = value;
            }
        });
        if (applicationSettings) {
            yield db.applicationSettings.update({
                where: {
                    applicationId
                },
                data: {
                    settings: existingSettings
                }
            });
        } else {
            yield db.applicationSettings.create({
                data: {
                    applicationId,
                    settings: existingSettings
                }
            });
        }
    });
    return function setSettings(applicationId, settings) {
        return _ref.apply(this, arguments);
    };
}();
export const parseApplication = (application)=>{
    const featuresEnabled = application.featuresEnabled ? application.featuresEnabled.split(",").map((f)=>f.trim()) : [];
    const crmMetadata = application.crmMetadata ? ApplicationCRMMetadataSchema.parse(application.crmMetadata) : {};
    return _object_spread_props(_object_spread({}, application), {
        crmMetadata,
        featuresEnabled
    });
};
export const parseApplicationSettings = (applicationSettings)=>{
    return _object_spread_props(_object_spread({}, applicationSettings), {
        settings: ApplicationSettingsSchema.parse(applicationSettings.settings)
    });
};
export const getOrganizationLocalizationTargets = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ applicationId }) {
        return new Promise((resolve, reject)=>{
            db.application.findUnique({
                where: {
                    id: applicationId
                },
                select: {
                    organizationId: true
                }
            }).then((application)=>{
                const { organizationId } = application;
                db.organizationLocalizationTarget.findMany({
                    where: {
                        organizationId
                    },
                    select: {
                        locale: true
                    }
                }).then((localizations)=>resolve(localizations));
            });
        });
    });
    return function getOrganizationLocalizationTargets(_) {
        return _ref.apply(this, arguments);
    };
}();
